/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';

import { cilLockLocked } from '@coreui/icons';
import { CCol, CRow } from '@coreui/react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { formValidator } from 'src/helpers/formValidator';
import { checkPasswordStrength } from 'src/helpers/getPasswordStrength';
import useApi from 'src/hooks/useApi';
import { useShowToast } from 'src/hooks/useShowToast';
import CustomInput from '../InputsComponent/CustomInput';
import Button from '../UI/Button';
import LoadingBtn from '../UI/LoadingBtn';

function ResetPassword(prop) {
  const { token, email, setOnTaskName } = prop;

  const { loading, postData } = useApi('/BlazorApi/forgot');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const showToast = useShowToast();

  const changePassword = async () => {
    const form = document.querySelector('.forgot-password-form');
    formValidator();
    if (form.checkValidity()) {
      if (password === confirmPassword) {
        const forgotPassword = {
          id: 0,
          dspid: 0,
          userId: '',
          userName: '',
          firstName: '',
          lastName: '',
          email: email,
          primaryContact: '',
          token: token,
          roleId: 0,
          password: btoa(password),
          rowVer: 0,
          status: 0,
          createdAt: moment().utc().format(),
          createdBy: 0,
        };
        const passRes = await postData(forgotPassword);
        if (passRes.status === true) {
          showToast('Password is reset successful, log in with your new credentials.');
          navigateToSignIn();
        } else {
          showToast(
            'Apologies, token might be expried; kindly retry later and contact support team',
            'error',
          );
        }
      } else showToast('Password and Confirm Password does not match', 'warning');
    }
  };

  const navigateToSignIn = () => {
    navigate('/');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form className="needs-validation forgot-password-form " onSubmit={handleSubmit} noValidate>
      <div className="centerimage">
        <img className="forgot-password-img" src="4DSPS_White.png" alt="logo" />
      </div>
      <div className="text-leftside mb-3">
        <h2 className="forgot-password-title text-center ">Reset Password</h2>
        <p className="forgot-password-email-title">
          This allows you to change password, need to set new password, will be logged out and need
          to login again.
        </p>
      </div>
      <CRow className="justify-content-center align-items-center">
        <CCol>
          <CustomInput
            label="New Password"
            value={password}
            autoComplete="off"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            icon={cilLockLocked}
            type="password"
            id="password"
            name="password"
            disabled={loading}
            placeholder="xxxxxxxx"
            isRequired={true}
            message="Enter password"
            title="Enter password"
          />
        </CCol>
      </CRow>
      <CustomInput
        label="Confirm New Password"
        value={confirmPassword}
        autoComplete="off"
        onChange={(e) => setConfirmPassword(e.target.value)}
        icon={cilLockLocked}
        type={showConfirmPassword ? 'text' : 'password'}
        id="confirmPassword"
        name="confirmPassword"
        disabled={loading}
        placeholder="xxxxxxxx"
        isRequired={true}
        message="Enter confirm password"
        title="Enter confirm password"
      />
      {password !== '' && (
        <p className="password-strength">Password Strength :{checkPasswordStrength(password)}</p>
      )}

      <div className="centerimage mt-2">
        {loading ? (
          <LoadingBtn title="Reseting password..." />
        ) : (
          <div className="d-flex row-gap-2 justify-content-center align-items-center column-gap-2">
            <Button title="Back" onClick={() => setOnTaskName('securityCode')} />
            <Button title="Cancel" onClick={navigateToSignIn} />
            <Button title="Submit" type="submit" onClick={changePassword} />
          </div>
        )}
      </div>
    </form>
  );
}
export default ResetPassword;
